import { autoinject } from 'aurelia-framework';
import { TabManager } from 'views/admin/mooring/tab-manager';

@autoinject
export class InvoiceSpagettiProductsTabXledger {
  constructor(protected tabManager: TabManager) {
    tabManager.tabActivated();
  }

  protected canDeactivate() {
    return this.tabManager.leaveTab();
  }
}
